import { render, staticRenderFns } from "./createAdminSession.vue?vue&type=template&id=2bd9e3d3&scoped=true&"
import script from "./createAdminSession.vue?vue&type=script&lang=js&"
export * from "./createAdminSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd9e3d3",
  null
  
)

export default component.exports